import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 bg-[#f5f0e6]" data-id="element-287">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-289">
          <h2 className="md:text-4xl font-extrabold text-[#1a3622] mb-6 text-balance text-[20px]" data-id="element-290">
            ❓ ¿Te suena conocido esto?
          </h2>

          <div className="space-y-6 text-lg text-[#4a3b32] text-left md:text-center max-w-3xl mx-auto" data-id="element-291">
            <p className="text-[16px]" data-id="element-292">
              Son las 10 de la noche. Mañana tenés que estudiar para el parcial
              de producción animal, preparar una clase sobre sistemas de riego o
              entender cómo funciona realmente la reproducción bovina en tu
              campo.
            </p>
            <p className="text-[16px]" data-id="element-293">
              Y seguís buscando. Un PDF aquí. Un video allá. Un apunte que no
              está completo. Un libro que explica la mitad y asume que ya sabés
              el resto.
            </p>
            <p data-id="element-294">
              <strong className="text-[#1a3622] text-[18px]" data-id="element-295">
                No es tu culpa. Es que el material agropecuario serio, completo
                y en español es casi imposible de encontrar — y cuando aparece,
                está fragmentado, desorganizado o cuesta una fortuna.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}